import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Styles from './components/Styles';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import FloatingCTAButton from '../../components/FloatingCTAButton';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0f0520] via-[#1a0b2e] to-[#2d1b4e] relative overflow-hidden">
      <Hero scrolled={scrolled} />
      <About />
      <Services />
      <Styles />
      <Portfolio />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingButtons />
      <FloatingCTAButton />
    </div>
  );
}
